var angular = require('angular')

angular.module('AemBranchesAppointments')
  .factory('appDataService', appDataService)

appDataService.$inject = ['$location', 'widgetParamsService']

function appDataService ($location, widgetParamsService) {
  var timeSelectOpen = {
    date: null,
    daypart: null
  }

  var self = {
    isTimeSelectOpen: isTimeSelectOpen,
    setTimeSelectOpen: setTimeSelectOpen,
    serviceGroups: {
      ASSISTANCE: {
        value: null
      },
      ATTENDANCE: {
        value: null
      }
    },
    sortedServices: [
      {
        key: 'WHEELCHAIR',
        group: 'ATTENDANCE'
      },
      {
        key: 'INTERPRETATION',
        group: 'ASSISTANCE'
      },
      {
        key: 'BLIND',
        group: 'ATTENDANCE'
      },
      {
        key: 'TRANSCRIPT',
        group: 'ASSISTANCE'
      }
    ],
    MEETING_LENGTH_MINUTES: 60,
    getNeedAnyService: getNeedAnyService,
    resetAllServices: resetAllServices,
    setQueryParams: setQueryParams,
    widgetParamsPromise: getWidgetParamsPromise()
  }

  self.serviceGroups.ATTENDANCE.value = $location.search().attendance
  self.serviceGroups.ASSISTANCE.value = $location.search().assistance

  function setQueryParams () {
    var attendance = self.serviceGroups.ATTENDANCE.value || null
    var assistance = self.serviceGroups.ASSISTANCE.value || null
    $location.search({ attendance: attendance, assistance: assistance })
  }

  function getNeedAnyService () {
    return !!(self.serviceGroups.ATTENDANCE.value || self.serviceGroups.ASSISTANCE.value)
  }

  function resetAllServices () {
    self.serviceGroups.ATTENDANCE.value = null
    self.serviceGroups.ASSISTANCE.value = null
  }

  function isTimeSelectOpen (date, daypart) {
    return timeSelectOpen.date === date && timeSelectOpen.daypart === daypart
  }

  function setTimeSelectOpen (date, daypart) {
    timeSelectOpen.date = date
    timeSelectOpen.daypart = daypart
  }

  function getWidgetParamsPromise () {
    return widgetParamsService.get('AemBranchesAppointments')
  }

  return self
}
